import * as React from "react";
import { useScrollComputed } from "./useScrollComputed";

export const useScrollOffsetGreaterThan = (offset = 80) => {
  const computeIsGreatedThan = React.useCallback(([distance]) => distance > offset, [offset]);
  return useScrollComputed({ computeValue: computeIsGreatedThan /*, debug: "IsGreatedThan" */ });
};
